// extracted by mini-css-extract-plugin
export var backButton = "MainMenuPanel-module--back-button--f2a4f";
export var content = "MainMenuPanel-module--content--a23a7";
export var groupTitleBox = "MainMenuPanel-module--group-title-box--8cf00";
export var groups = "MainMenuPanel-module--groups--6ed04";
export var subMenu = "MainMenuPanel-module--sub-menu--7a20e";
export var subMenuExpanded = "MainMenuPanel-module--sub-menu-expanded--22a34";
export var trendingNow = "MainMenuPanel-module--trending-now--df3fe";
export var withTrendingNow = "MainMenuPanel-module--with-trending-now--8ce2e";